import { Box, useTheme } from "@mui/material";
import { TIME_PERIODS } from "../../../Redux/Reducers/strategyStoreSlice";

const TimePeriodToggle = ({ value, onChange }) => {
  const theme = useTheme();

  return (
    <Box sx={{ mb: 4, display: "flex", gap: 1 }}>
      {TIME_PERIODS.filter((p) => p.key !== "custom").map((period) => {
        const selected = value === period.key;
        return (
          <Box
            key={period.key}
            component="button"
            onClick={() => onChange(null, period.key)}
            sx={{
              px: 1.5,
              py: 0.75,
              borderRadius: 1,
              border: selected ? "none" : `1px solid ${theme.palette.divider}`,
              backgroundColor: selected
                ? theme.palette.primary.main
                : theme.palette.background.paper,
              color: selected ? "#fff" : theme.palette.text.secondary,
              fontSize: "0.75rem",
              fontWeight: 500,
              letterSpacing: "0.05em",
              cursor: "pointer",
              transition: "all 0.15s",
              "&:hover": selected
                ? {}
                : {
                    backgroundColor: theme.palette.action.hover,
                    borderColor: theme.palette.primary.main,
                    color: theme.palette.text.primary,
                  },
            }}
          >
            {period.label.toUpperCase()}
          </Box>
        );
      })}
    </Box>
  );
};

export default TimePeriodToggle;

